import { Observable, Subject } from "rxjs";
import { ConfigService } from "../config/config.service";
import { Inject, Injectable } from "@angular/core";
import kountSDK from 'node_modules/@kount/kount-web-client-sdk';
import { UserSessionService } from "../user-session/user-session.service";
import {Platform} from '@ionic/angular';

declare var window:any;

@Injectable()
export class DeviceDetailsCollectorService {
    clientID;
    constructor(
        private config:ConfigService,
        private userSessionService:UserSessionService,
	private platform: Platform
    ) {
        this.clientID = this.config.getConfig().FEATURE_KOUNT_CLIENT_ID ?? 100843;
    }

   
    async onDoCollectionClick() {
        let sessionID: string = this.userSessionService.getSessionToken();
        if( sessionID) {
            sessionID = sessionID.slice(0, 32);
        }
    	if( this.platform.is('capacitor') || this.platform.is('cordova')) {
            console.log( 'Kount: calling initialize( '
                +this.clientID+', '
                +sessionID
            );
            window.cordova.plugins.Kount.initialize( {
                clientID: this.clientID,
                sessionID: sessionID,
            });
        } else {
            let kountConfig = {
                clientID: this.clientID,
                environment: "TEST",
                isSinglePageApp: true,
                isDebugEnabled: true,
            };
            kountSDK(kountConfig, sessionID);
        }
    }

}
